import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(cents: number): string {
  const value = cents / 100;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

// Remove recursivamente propriedades undefined de um objeto, preservando tipos do Firestore
export function cleanObject(obj: any): any {
  if (obj === undefined) return undefined;
  if (obj === null) return null;

  if (Array.isArray(obj)) {
    return obj.map((item) => cleanObject(item)).filter((v) => v !== undefined);
  }

  if (obj !== null && typeof obj === "object") {
    // Preservar instâncias de Date
    if (obj instanceof Date) return obj;

    // Detectar objetos especiais do Firestore (Timestamp ou FieldValue)
    // Eles não devem sofrer limpeza recursiva pois perdem seu comportamento interno
    const isFirestoreSpecial =
      obj.constructor?.name === "Timestamp" ||
      obj.constructor?.name === "FieldValue" ||
      (obj.seconds !== undefined && obj.nanoseconds !== undefined) ||
      obj._methodName !== undefined;

    if (isFirestoreSpecial) return obj;

    // Limpeza recursiva apenas para objetos planos
    return Object.fromEntries(
      Object.entries(obj)
        .map(([k, v]) => [k, cleanObject(v)])
        .filter(([_, v]) => v !== undefined),
    );
  }

  return obj;
}

// Mensagem de erro pronta para toast.
//
// As funções de auth/lib lançam Error com texto já traduzido; qualquer outra
// coisa (string solta, rejeição do SDK sem message) cai no fallback em vez de
// mostrar "undefined" ou um código em inglês para o usuário.
export function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
